import type { AccessAdmins } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getAccessAdmins = async (): Promise<AccessAdmins> => {
  const response = await apiClient.get<AccessAdmins>('/me/access-admins');
  return response.data;
};
